import { render } from "./ActivityTask.vue?vue&type=template&id=4982e18d"
import script from "./ActivityTask.vue?vue&type=script&lang=js"
export * from "./ActivityTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__